import {ForwardedRef, forwardRef} from 'react'
import clsx from 'clsx'

import {BoxProps} from './types'

const Box = forwardRef(
  (
    {
      children,
      id,
      onMouseEnter,
      onMouseLeave,
      onPress,
      className,
      ...rest
    }: BoxProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <div
      ref={ref}
      className={clsx('flex', className)}
      id={id}
      onClick={onPress}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rest}>
      {children}
    </div>
  )
)

Box.displayName = 'Box'

export default Box
